module.exports = __webpack_public_path__ + "static/media/porto.66b882da.svg";